import { Box, Paper, keyframes } from "@mui/material";

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
  40% { transform: translateY(-4px); opacity: 1; }
`;

export default function ThinkingBubble() {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", my: 0.5 }}>
      <Paper
        elevation={0}
        sx={{
          px: 1.75,
          py: 1.25,
          bgcolor: "grey.100",
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "text.secondary",
              animation: `${bounce} 1.2s infinite ease-in-out`,
              animationDelay: `${i * 0.16}s`,
            }}
          />
        ))}
      </Paper>
    </Box>
  );
}
